import classNames from "classnames";
import React, { useRef } from "react";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;

  /**
   * 無効かどうか
   */
  disabled?: boolean;

  /**
   * 読み取り専用かどうか
   */
  isReadonly?: boolean;

  /**
   * エラー
   */
  error?: boolean;

  /**
   * 有効な値
   */
  valid?: boolean;

  /**
   * 横幅
   */
  width?: "3s" | "2s" | "s" | "m" | "ml" | "l" | "2l" | "full";
  /**
   * 高さ
   */
  height?: "s" | "m" | "l" | "2l" | "3l";

  /**
   * 最小幅
   */
  minWidth?: string;
}

const Select: React.FC<SelectProps> & {
  Option: typeof SelectOption;
} = ({
  className,
  disabled = false,
  isReadonly = false,
  error = false,
  valid = false,
  width,
  height,
  children,
  minWidth,
  ...props
}) => {
  const classes = classNames(
    "uc-select",
    className,
    width && `uc-select--w${width === "full" ? "-" : ""}${width}`,
    height && `uc-select--h${height}`,
    disabled && "uc-select--disabled",
    isReadonly && "uc-select--readonly",
    error && "uc-select--error",
    valid && "uc-select--success"
  );

  const ref = useRef<HTMLSelectElement>(null);

  return (
    <div
      className={classes}
      onClick={(event) => disabled && event.preventDefault()}
    >
      <select
        {...props}
        ref={ref}
        onChange={(e) => {
          props?.onChange?.(e);
          ref.current?.blur();
        }}
        disabled={disabled}
        style={{ pointerEvents: disabled ? "none" : "auto", minWidth: minWidth ?? "auto" }}
      >
        {children}
      </select>
    </div>
  );
};

export interface SelectOptionProps
  extends React.OptionHTMLAttributes<HTMLOptionElement> {}

const SelectOption: React.FC<SelectOptionProps> = ({ children, ...props }) => {
  return <option {...props}>{children}</option>;
};

Select.Option = SelectOption;

export default Select;
